import { Star, Zap, Trophy } from "lucide-react";

export default function StatusBadges({ coachPro, foundingMember, adFounder, className = "" }) {
  if (!coachPro && !foundingMember && !adFounder) return null;
  return (
    <div className={`inline-flex flex-wrap items-center gap-1.5 ${className}`} data-testid="status-badges">
      {foundingMember && (
        <span
          data-testid="badge-founding-member"
          title="Founding Member — joined during the founding window"
          className="inline-flex items-center gap-1 px-2 py-0.5 text-[9px] tracking-widest heading bg-amber-400 text-black"
        >
          <Star size={9} fill="currentColor" /> FOUNDING MEMBER
        </span>
      )}
      {coachPro && (
        <span
          data-testid="badge-coach-pro"
          title="Coach Pro subscriber"
          className="inline-flex items-center gap-1 px-2 py-0.5 text-[9px] tracking-widest heading bg-volt text-white"
        >
          <Zap size={9} fill="currentColor" /> COACH PRO
        </span>
      )}
      {adFounder && (
        <span
          data-testid="badge-ad-founder"
          title="AD Founder — founding program partner"
          className="inline-flex items-center gap-1 px-2 py-0.5 text-[9px] tracking-widest heading bg-blaze text-white"
        >
          <Trophy size={9} /> AD FOUNDER
        </span>
      )}
    </div>
  );
}
